import axios from 'axios'
import * as Config from '../../config'

const state = {
    users: {
        current_page: 1,
        data: [],
    },
    contact: {},
}

const actions = {

    StoreContact({ commit, dispatch }, form) {
        commit('STORE_CONTACT')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/contact/store', form)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            //commit('STORE_CONTACT_OK')
                            resolve(response.data)
                        } else {
                           // commit('STORE_CONTACT_FAIL')
                            reject(response.data)
                        }

                    })
                .catch(error => {
                   // commit('STORE_CONTACT_FAIL')
                    reject(error.data)
                })
        })


    },
    load_Contacts({ commit, dispatch }) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'user/contact/list/all')
                .then(
                    response => {
                        //commit('LOAD_CATEGORIES',response.data)
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_Contacts_By_Client({ commit, dispatch },form) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'user/contact/user/'+form.id)
                .then(
                    response => {
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_Contact({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'user/contact/consult/' + form.id)
                .then(
                    response => {
                        //commit('LOAD_CATEGORY', data);
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });

    },
    changeActive_Contact({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'user/contact/change/active/' + form.id + '/' + form.active)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
}

const mutations = {

}

export default {
    state,
    actions,
    mutations
}
